<template>
  <tr
    class="clickable"
    @click="goToYacht(yacht.id)"
  >
    <td>
      <strong>{{ yacht.id }}</strong>
    </td>
    <td>
      <div
        v-if="!yacht.name"
        class="grey--text text--lighten-1"
      >
        No Name
      </div>
      <div v-else>
        {{ yacht.name }}
      </div>
    </td>
    <td>
      <div
        v-if="!yacht.hull_number"
        class="grey--text text--lighten-1"
      >
        n/a
      </div>
      <div v-else>
        {{ yacht.hull_number }}
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        v-if="!yacht.model.full_label"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div
        v-else
        style="max-width: 150px; text-overflow: ellipsis; overflow: hidden"
      >
        {{ yacht.model.label }}
        <div class="font-weight-light grey--text text--darken-2">
          {{ yacht.model.manufacturer.name }} &middot; #{{ yacht.model.id }}
        </div>
      </div>
    </td>
    <td>
      <div
        v-if="!yacht.production_year"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.production_year }}
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        v-if="yacht.country"
        style="max-width: 110px"
        class="text-truncate"
      >
        <flag
          v-if="yacht.country"
          :iso="yacht.country.code"
          class="mr-1"
          :squared="false"
        />
        <span
          v-if="yacht.current_base"
        >
          {{ yacht.current_base.name }}
        </span>
      </div>
      <div
        v-else
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
    </td>
    <td class="px-0">
      <v-chip
        small
        :color="investmentStatusData[yacht.investment_status].color"
        text-color="white"
        class="ma-0 caption"
      >
        {{ investmentStatusData[yacht.investment_status].label }}
      </v-chip>
    </td>
    <td v-if="$can('view', 'Owner')">
      <div
        v-if="!yacht.owner"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.owner.name }}
      </div>
    </td>
  </tr>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'YachtInCharterRow',
    props: {
      yacht: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        statusData: Yacht.statusData,
        investmentStatusData: Yacht.investmentStatusData
      }
    },
    methods: {
      goToYacht(yachtId) {
        let route = this.$router.resolve({ name: 'yachtDashboard', params: { id: yachtId } })

        window.open(route.href, '_blank')
      }
    }
  }
</script>

<style scoped>

</style>
